export const config = {
  submissionName: {
    required: true,
    rules: [
      (value: string) => ({
        valid: !/[\\/*?":|<>]/g.test(value),
        'data-error': 'v_templateIllegalCharacters'
      }),
      (value: string) => ({
        valid: value.length <= 150,
        'data-error': 'v_templateNameTooLong'
      })
    ]
  },
  mediaAssetsNumber: { value: '' },
  project: { required: true, value: null },
  projectManager: { required: true, value: [] },
  dueDate: { value: 'specificDate' },
  templateDueDateInDays: { value: null },
  specificDate: { value: null },
  sourceLanguage: { required: true, value: null },
  targetLanguage: { required: true, value: [], disabled: true },
  workflow: { required: true, value: null },
  instructions: { value: '' },
  notes: { value: '' },
  referenceFiles: { value: [] },
  uploadedFiles: { value: [] },
  deletedFiles: { value: [] },
  isFavorite: { value: false },
  batchId: { value: null },
  claimScope: { required: true, value: 'LANGUAGE' },
  targetFormat: { value: null },
  description: { value: '' },
  quoteEnabled: { value: false },
  isMultiBatch: { value: false }
};

/**
 * Form configuration for TPT(internal mode)
 */
export const tptTemplateConfig = {
  ...config,
  job: { required: true, value: '' },
  paClient: { required: true, value: null }
};